import { Injectable, Inject } from "@angular/core";
import { TRANSLATIONS } from "./translation";

@Injectable()
export class TranslateService {
	private _currentLang: string;

	public get currentLang() {
		return this._currentLang;
	}

	// inject our translations
	constructor(@Inject(TRANSLATIONS) private _translations: any) {
	}

	public use(lang: string): void {
		// set current language
		this._currentLang = lang;
	}

	public translate(key: string): string {
		// private perform translation
		const translation = key;

		// try language of choice
		if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
			return this._translations[this.currentLang][key];
		}

		// try proper nouns constant
		if (this._translations["proper"] && this._translations["proper"][key]) {
			return this._translations["proper"][key];
		}

		// fall back to english if not in files above
		if (this._translations["en"] && this._translations["en"][key]) {
			return this._translations["en"][key];
		}

		return translation;
	}

	public instant(key: string) {
		// call translation
		return this.translate(key);
	}
}
